import { useContext } from 'react';
import { ReserveComputationTableContext, IReserveComputationTableContext } from './ReserveComputationTableContext';

export const useReserveComputationTable = () =>
    useContext<IReserveComputationTableContext>(ReserveComputationTableContext);
